import {
  ContentBlock,
  Heading,
  Stack,
  Columns,
  Column,
  Box,
} from 'braid-design-system';
import React from 'react';

import { CTAButton } from 'src/components';
import { CREATE_JOB, REGISTER } from 'src/shared/links';

import * as styles from './PromoFooter.css';

const PromoFooter = ({ title }: { title: string }) => (
  <Box paddingTop={['none', 'xlarge']}>
    <Box style={{ backgroundColor: '#fbe7cf' }} paddingX={['gutter', 'none']}>
      <ContentBlock>
        <Box position="relative" className={styles.orangeStar}>
          <Columns
            collapseBelow="tablet"
            reverse
            space="gutter"
            alignY="center"
          >
            <Column width="1/2">
              <Box
                paddingY={['xxlarge', 'xlarge']}
                textAlign={['center', 'left']}
              >
                <Stack space="large">
                  <Heading level="3">{title}</Heading>
                  <CTAButton
                    color="blue"
                    text={{
                      loggedIn: 'Create a job ad',
                      loggedOut: 'Get started',
                    }}
                    href={{
                      loggedIn: CREATE_JOB,
                      loggedOut: REGISTER,
                    }}
                    tracking={{
                      loggedIn: 'create_job_link_pressed',
                      loggedOut: 'register_link_pressed',
                    }}
                  />
                </Stack>
              </Box>
            </Column>
            <Column width="1/2">
              <Box className={styles.introImg} paddingTop={['small', 'none']} />
            </Column>
          </Columns>
        </Box>
      </ContentBlock>
    </Box>
  </Box>
);

export default PromoFooter;
